import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { ExternalContentBlockProps, ExternalContentInteractions } from './partials/ExternalContentInteractions';
import { ExternalContentDefaultView } from './views/ExternalContentDefaultView';

function ExternalContent({ views, activeView = 'default' }: ExternalContentBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <ExternalContentInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <ExternalContentDefaultView {...views.default} />;
  }
}

export const ExternalContentBlock = asFetchableBlock(ExternalContent, BlockType.externalcontent);
export type ExternalContentBlock = ComponentProps<typeof ExternalContentBlock>;
